const city = [{
  'zh': '阿坝藏族羌族自治州',
  'en': 'Aba'
},
{
  'zh': '阿克苏地区',
  'en': 'Akesu'
},
{
  'zh': '阿拉善盟',
  'en': 'Alashanmeng'
},
{
  'zh': '阿勒泰地区',
  'en': 'Aletai'
},
{
  'zh': '阿里地区',
  'en': 'Ali'
},
{
  'zh': '安康市',
  'en': 'Ankang'
},
{
  'zh': '安庆市',
  'en': 'Anqing'
},
{
  'zh': '鞍山市',
  'en': 'Anshan'
},
{
  'zh': '安顺市',
  'en': 'Anshun'
},
{
  'zh': '安阳市',
  'en': 'Anyang'
},
{
  'zh': '白城市',
  'en': 'Baicheng'
},
{
  'zh': '百色市',
  'en': 'Baise'
},
{
  'zh': '白山市',
  'en': 'Baishan'
},
{
  'zh': '白银市',
  'en': 'Baiyin'
},
{
  'zh': '保定市',
  'en': 'Baoding'
},
{
  'zh': '宝鸡市',
  'en': 'Baoji'
},
{
  'zh': '保山市',
  'en': 'Baoshan'
},
{
  'zh': '包头市',
  'en': 'Baotou'
},
{
  'zh': '巴彦淖尔市',
  'en': 'Bayannur'
},
{
  'zh': '巴音郭楞蒙古自治州',
  'en': 'Bayinguoleng'
},
{
  'zh': '巴中市',
  'en': 'Bazhong'
},
{
  'zh': '北海市',
  'en': 'Beihai'
},
{
  'zh': '北京市',
  'en': 'Beijing'
},
{
  'zh': '蚌埠市',
  'en': 'Bengbu'
},
{
  'zh': '本溪市',
  'en': 'Benxi'
},
{
  'zh': '毕节市',
  'en': 'Bijie'
},
{
  'zh': '滨州市',
  'en': 'Binzhou'
},
{
  'zh': '博尔塔拉蒙古自治州',
  'en': 'Boertala'
},
{
  'zh': '亳州市',
  'en': 'Bozhou'
},
{
  'zh': '沧州市',
  'en': 'Cangzhou'
},
{
  'zh': '昌都市',
  'en': 'Chamdo'
},
{
  'zh': '长春市',
  'en': 'Changchun'
},
{
  'zh': '常德市',
  'en': 'Changde'
},
{
  'zh': '昌都地区',
  'en': 'Changdou'
},
{
  'zh': '昌吉回族自治州',
  'en': 'Changji'
},
{
  'zh': '长沙市',
  'en': 'Changsha'
},
{
  'zh': '长治市',
  'en': 'Changzhi'
},
{
  'zh': '常州市',
  'en': 'Changzhou'
},
{
  'zh': '巢湖市',
  'en': 'Chaohu'
},
{
  'zh': '朝阳市',
  'en': 'Chaoyang'
},
{
  'zh': '潮州市',
  'en': 'Chaozhou'
},
{
  'zh': '承德市',
  'en': 'Chengde'
},
{
  'zh': '成都市',
  'en': 'Chengdu'
},
{
  'zh': '郴州市',
  'en': 'Chenzhou'
},
{
  'zh': '赤峰市',
  'en': 'Chifeng'
},
{
  'zh': '池州市',
  'en': 'Chizhou'
},
{
  'zh': '重庆市',
  'en': 'Chongqing'
},
{
  'zh': '崇左市',
  'en': 'Chongzuo'
},
{
  'zh': '楚雄彝族自治州',
  'en': 'Chuxiong'
},
{
  'zh': '滁州市',
  'en': 'Chuzhou'
},
{
  'zh': '大理白族自治州',
  'en': 'Dali'
},
{
  'zh': '大连市',
  'en': 'Dalian'
},
{
  'zh': '丹东市',
  'en': 'Dandong'
},
{
  'zh': '儋州市',
  'en': 'Danzhou'
},
{
  'zh': '大庆市',
  'en': 'Daqing'
},
{
  'zh': '大同市',
  'en': 'Datong'
},
{
  'zh': '大兴安岭地区',
  'en': 'Daxinganling'
},
{
  'zh': '达州市',
  'en': 'Dazhou'
},
{
  'zh': '德宏傣族景颇族自治州',
  'en': 'Dehong'
},
{
  'zh': '德阳市',
  'en': 'Deyang'
},
{
  'zh': '德州市',
  'en': 'Dezhou'
},
{
  'zh': '定西市',
  'en': 'Dingxi'
},
{
  'zh': '迪庆藏族自治州',
  'en': 'Diqing'
},
{
  'zh': '东莞市',
  'en': 'Dongguan'
},
{
  'zh': '东营市',
  'en': 'Dongying'
},
{
  'zh': '恩施土家族苗族自治州',
  'en': 'Enshi'
},
{
  'zh': '鄂州市',
  'en': 'Ezhou'
},
{
  'zh': '防城港市',
  'en': 'Fangchenggang'
},
{
  'zh': '佛山市',
  'en': 'Foshan'
},
{
  'zh': '抚顺市',
  'en': 'Fushun'
},
{
  'zh': '阜新市',
  'en': 'Fuxin'
},
{
  'zh': '阜阳市',
  'en': 'Fuyang'
},
{
  'zh': '福州市',
  'en': 'Fuzhou'
},
{
  'zh': '甘南藏族自治州',
  'en': 'Gannan'
},
{
  'zh': '赣州市',
  'en': 'Ganzhou'
},
{
  'zh': '甘孜藏族自治州',
  'en': 'Ganzi'
},
{
  'zh': '广安市',
  'en': "Guang'an"
},
{
  'zh': '广元市',
  'en': 'Guangyuan'
},
{
  'zh': '广州市',
  'en': 'Guangzhou'
},
{
  'zh': '贵港市',
  'en': 'Guigang'
},
{
  'zh': '桂林市',
  'en': 'Guilin'
},
{
  'zh': '贵阳市',
  'en': 'Guiyang'
},
{
  'zh': '果洛藏族自治州',
  'en': 'Guoluo'
},
{
  'zh': '固原市',
  'en': 'Guyuan'
},
{
  'zh': '海北藏族自治州',
  'en': 'Haibei'
},
{
  'zh': '海东市',
  'en': 'Haidong'
},
{
  'zh': '海口市',
  'en': 'Haikou'
},
{
  'zh': '海南藏族自治州',
  'en': 'Hainan'
},
{
  'zh': '海西蒙古族藏族自治州',
  'en': 'Haixi'
},
{
  'zh': '哈密地区',
  'en': 'Hami'
},
{
  'zh': '邯郸市',
  'en': 'Handan'
},
{
  'zh': '杭州市',
  'en': 'Hangzhou'
},
{
  'zh': '汉中市',
  'en': 'Hanzhong'
},
{
  'zh': '哈尔滨市',
  'en': 'Harbin'
},
{
  'zh': '鹤壁市',
  'en': 'Hebi'
},
{
  'zh': '河池市',
  'en': 'Hechi'
},
{
  'zh': '合肥市',
  'en': 'Hefei'
},
{
  'zh': '鹤岗市',
  'en': 'Hegang'
},
{
  'zh': '黑河市',
  'en': 'Heihe'
},
{
  'zh': '衡水市',
  'en': 'Hengshui'
},
{
  'zh': '衡阳市',
  'en': 'Hengyang'
},
{
  'zh': '和田地区',
  'en': 'Hetian'
},
{
  'zh': '河源市',
  'en': 'Heyuan'
},
{
  'zh': '菏泽市',
  'en': 'Heze'
},
{
  'zh': '贺州市',
  'en': 'Hezhou'
},
{
  'zh': '呼和浩特市',
  'en': 'Hohhot'
},
{
  'zh': '香港',
  'en': 'Hong Kong'
},
{
  'zh': '红河哈尼族彝族自治州',
  'en': 'Honghe'
},
{
  'zh': '新竹市',
  'en': 'Hsinchu'
},
{
  'zh': '淮北市',
  'en': 'Huaibei'
},
{
  'zh': '怀化市',
  'en': 'Huaihua'
},
{
  'zh': '淮南市',
  'en': 'Huainan'
},
{
  'zh': '黄冈市',
  'en': 'Huanggang'
},
{
  'zh': '黄南藏族自治州',
  'en': 'Huangnan'
},
{
  'zh': '黄山市',
  'en': 'Huangshan'
},
{
  'zh': '黄石市',
  'en': 'Huangshi'
},
{
  'zh': '惠州市',
  'en': 'Huizhou'
},
{
  'zh': '葫芦岛市',
  'en': 'Huludao'
},
{
  'zh': '呼伦贝尔市',
  'en': 'Hulunbuir'
},
{
  'zh': '湖州市',
  'en': 'Huzhou'
},
{
  'zh': '吉安市',
  'en': "Ji'an"
},
{
  'zh': '佳木斯市',
  'en': 'Jiamusi'
},
{
  'zh': '江门市',
  'en': 'Jiangmen'
},
{
  'zh': '焦作市',
  'en': 'Jiaozuo'
},
{
  'zh': '嘉兴市',
  'en': 'Jiaxing'
},
{
  'zh': '嘉义市',
  'en': 'Jiayi'
},
{
  'zh': '嘉峪关市',
  'en': 'Jiayuguan'
},
{
  'zh': '揭阳市',
  'en': 'Jieyang'
},
{
  'zh': '吉林市',
  'en': 'Jilin'
},
{
  'zh': '济南市',
  'en': 'Jinan'
},
{
  'zh': '金昌市',
  'en': 'Jinchang'
},
{
  'zh': '晋城市',
  'en': 'Jincheng'
},
{
  'zh': '景德镇市',
  'en': 'Jingdezhen'
},
{
  'zh': '荆门市',
  'en': 'Jingmen'
},
{
  'zh': '荆州市',
  'en': 'Jingzhou'
},
{
  'zh': '金华市',
  'en': 'Jinhua'
},
{
  'zh': '济宁市',
  'en': 'Jining'
},
{
  'zh': '晋中市',
  'en': 'Jinzhong'
},
{
  'zh': '锦州市',
  'en': 'Jinzhou'
},
{
  'zh': '九江市',
  'en': 'Jiujiang'
},
{
  'zh': '酒泉市',
  'en': 'Jiuquan'
},
{
  'zh': '鸡西市',
  'en': 'Jixi'
},
{
  'zh': '开封市',
  'en': 'Kaifeng'
},
{
  'zh': '高雄市',
  'en': 'Kaohsiung'
},
{
  'zh': '克拉玛依市',
  'en': 'Karamay'
},
{
  'zh': '喀什地区',
  'en': 'Kashen'
},
{
  'zh': '基隆市',
  'en': 'Keelung'
},
{
  'zh': '克孜勒苏柯尔克孜自治州',
  'en': 'Kezilesukeerkezi'
},
{
  'zh': '昆明市',
  'en': 'Kunming'
},
{
  'zh': '来宾市',
  'en': 'Laibin'
},
{
  'zh': '莱芜市',
  'en': 'Laiwu'
},
{
  'zh': '廊坊市',
  'en': 'Langfang'
},
{
  'zh': '兰州市',
  'en': 'Lanzhou'
},
{
  'zh': '乐山市',
  'en': 'Leshan'
},
{
  'zh': '拉萨市',
  'en': 'Lhasa'
},
{
  'zh': '凉山彝族自治州',
  'en': 'Liangshan'
},
{
  'zh': '连云港市',
  'en': 'Lianyungang'
},
{
  'zh': '聊城市',
  'en': 'Liaocheng'
},
{
  'zh': '辽阳市',
  'en': 'Liaoyang'
},
{
  'zh': '辽源市',
  'en': 'Liaoyuan'
},
{
  'zh': '丽江市',
  'en': 'Lijiang'
},
{
  'zh': '临沧市',
  'en': 'Lincang'
},
{
  'zh': '临汾市',
  'en': 'Linfen'
},
{
  'zh': '锡林郭勒盟',
  'en': 'Linguolexi'
},
{
  'zh': '临沂市',
  'en': 'Linyi'
},
{
  'zh': '林芝地区',
  'en': 'Linzhi'
},
{
  'zh': '丽水市',
  'en': 'Lishui'
},
{
  'zh': '六盘水市',
  'en': 'Liupanshui'
},
{
  'zh': '柳州市',
  'en': 'Liuzhou'
},
{
  'zh': '陇南市',
  'en': 'Longnan'
},
{
  'zh': '龙岩市',
  'en': 'Longyan'
},
{
  'zh': '娄底市',
  'en': 'Loudi'
},
{
  'zh': '六安市',
  'en': "Lu'an"
},
{
  'zh': '漯河市',
  'en': 'Luohe'
},
{
  'zh': '洛阳市',
  'en': 'Luoyang'
},
{
  'zh': '泸州市',
  'en': 'Luzhou'
},
{
  'zh': '吕梁市',
  'en': 'Lüliang'
},
{
  'zh': '马鞍山市',
  'en': "Ma'anshan"
},
{
  'zh': '澳门',
  'en': 'Macao'
},
{
  'zh': '茂名市',
  'en': 'Maoming'
},
{
  'zh': '眉山市',
  'en': 'Meishan'
},
{
  'zh': '梅州市',
  'en': 'Meizhou'
},
{
  'zh': '绵阳市',
  'en': 'Mianyang'
},
{
  'zh': '牡丹江市',
  'en': 'Mudanjiang'
},
{
  'zh': '南昌市',
  'en': 'Nanchang'
},
{
  'zh': '南充市',
  'en': 'Nanchong'
},
{
  'zh': '南京市',
  'en': 'Nanjing'
},
{
  'zh': '南宁市',
  'en': 'Nanning'
},
{
  'zh': '南平市',
  'en': 'Nanping'
},
{
  'zh': '南通市',
  'en': 'Nantong'
},
{
  'zh': '南阳市',
  'en': 'Nanyang'
},
{
  'zh': '那曲地区',
  'en': 'Naqu'
},
{
  'zh': '内江市',
  'en': 'Neijiang'
},
{
  'zh': '宁波市',
  'en': 'Ningbo'
},
{
  'zh': '宁德市',
  'en': 'Ningde'
},
{
  'zh': '怒江傈僳族自治州',
  'en': 'Nujiang'
},
{
  'zh': '林芝市',
  'en': 'Nyingchi'
},
{
  'zh': '鄂尔多斯市',
  'en': 'Ordos'
},
{
  'zh': '盘锦市',
  'en': 'Panjin'
},
{
  'zh': '攀枝花市',
  'en': 'Panzhihua'
},
{
  'zh': '平顶山市',
  'en': 'Pingdingshan'
},
{
  'zh': '平凉市',
  'en': 'Pingliang'
},
{
  'zh': '萍乡市',
  'en': 'Pingxiang'
},
{
  'zh': '普洱市',
  'en': "Pu'er"
},
{
  'zh': '莆田市',
  'en': 'Putian'
},
{
  'zh': '濮阳市',
  'en': 'Puyang'
},
{
  'zh': '黔东南苗族侗族自治州',
  'en': 'Qiandongnan'
},
{
  'zh': '黔南布依族苗族自治州',
  'en': 'Qiannan'
},
{
  'zh': '黔西南布依族苗族自治州',
  'en': 'Qianxinan'
},
{
  'zh': '青岛市',
  'en': 'Qingdao'
},
{
  'zh': '庆阳市',
  'en': 'Qingyang'
},
{
  'zh': '清远市',
  'en': 'Qingyuan'
},
{
  'zh': '秦皇岛市',
  'en': 'Qinhuangdao'
},
{
  'zh': '钦州市',
  'en': 'Qinzhou'
},
{
  'zh': '齐齐哈尔市',
  'en': 'Qiqihar'
},
{
  'zh': '七台河市',
  'en': 'Qitaihe'
},
{
  'zh': '泉州市',
  'en': 'Quanzhou'
},
{
  'zh': '曲靖市',
  'en': 'Qujing'
},
{
  'zh': '衢州市',
  'en': 'Quzhou'
},
{
  'zh': '日喀则地区',
  'en': 'Rikaze'
},
{
  'zh': '日照市',
  'en': 'Rizhao'
},
{
  'zh': '三门峡市',
  'en': 'Sanmenxia'
},
{
  'zh': '三明市',
  'en': 'Sanming'
},
{
  'zh': '三亚市',
  'en': 'Sanya'
},
{
  'zh': '上海市',
  'en': 'Shanghai'
},
{
  'zh': '商洛市',
  'en': 'Shangluo'
},
{
  'zh': '商丘市',
  'en': 'Shangqiu'
},
{
  'zh': '上饶市',
  'en': 'Shangrao'
},
{
  'zh': '山南市',
  'en': 'Shannan'
},
{
  'zh': '汕头市',
  'en': 'Shantou'
},
{
  'zh': '汕尾市',
  'en': 'Shanwei'
},
{
  'zh': '韶关市',
  'en': 'Shaoguan'
},
{
  'zh': '绍兴市',
  'en': 'Shaoxing'
},
{
  'zh': '邵阳市',
  'en': 'Shaoyang'
},
{
  'zh': '沈阳市',
  'en': 'Shenyang'
},
{
  'zh': '深圳市',
  'en': 'Shenzhen'
},
{
  'zh': '日喀则市',
  'en': 'Shigatse'
},
{
  'zh': '石家庄市',
  'en': 'Shijiazhuang'
},
{
  'zh': '十堰市',
  'en': 'Shiyan'
},
{
  'zh': '石嘴山市',
  'en': 'Shizuishan'
},
{
  'zh': '双鸭山市',
  'en': 'Shuangyashan'
},
{
  'zh': '朔州市',
  'en': 'Shuozhou'
},
{
  'zh': '四平市',
  'en': 'Siping'
},
{
  'zh': '松原市',
  'en': 'Songyuan'
},
{
  'zh': '绥化市',
  'en': 'Suihua'
},
{
  'zh': '遂宁市',
  'en': 'Suining'
},
{
  'zh': '随州市',
  'en': 'Suizhou'
},
{
  'zh': '宿迁市',
  'en': 'Suqian'
},
{
  'zh': '苏州市',
  'en': 'Suzhou'
},
{
  'zh': '塔城地区',
  'en': 'Tacheng'
},
{
  'zh': '泰安市',
  'en': "Tai'an"
},
{
  'zh': '台中市',
  'en': 'Taichung'
},
{
  'zh': '台南市',
  'en': 'Tainan'
},
{
  'zh': '台北市',
  'en': 'Taipei'
},
{
  'zh': '太原市',
  'en': 'Taiyuan'
},
{
  'zh': '台州市',
  'en': 'Taizhou'
},
{
  'zh': '唐山市',
  'en': 'Tangshan'
},
{
  'zh': '桃园市',
  'en': 'Taoyuan'
},
{
  'zh': '天津市',
  'en': 'Tianjin'
},
{
  'zh': '天水市',
  'en': 'Tianshui'
},
{
  'zh': '铁岭市',
  'en': 'Tieling'
},
{
  'zh': '铜川市',
  'en': 'Tongchuan'
},
{
  'zh': '通化市',
  'en': 'Tonghua'
},
{
  'zh': '通辽市',
  'en': 'Tongliao'
},
{
  'zh': '铜陵市',
  'en': 'Tongling'
},
{
  'zh': '铜仁市',
  'en': 'Tongren'
},
{
  'zh': '吐鲁番地区',
  'en': 'Tulufan'
},
{
  'zh': '吐鲁番市',
  'en': 'Turpan'
},
{
  'zh': '乌兰察布市',
  'en': 'Ulanqab'
},
{
  'zh': '乌鲁木齐市',
  'en': 'Urumqi'
},
{
  'zh': '潍坊市',
  'en': 'Weifang'
},
{
  'zh': '威海市',
  'en': 'Weihai'
},
{
  'zh': '渭南市',
  'en': 'Weinan'
},
{
  'zh': '文山壮族苗族自治州',
  'en': 'Wenshan'
},
{
  'zh': '温州市',
  'en': 'Wenzhou'
},
{
  'zh': '乌海市',
  'en': 'Wuhai'
},
{
  'zh': '武汉市',
  'en': 'Wuhan'
},
{
  'zh': '芜湖市',
  'en': 'Wuhu'
},
{
  'zh': '武威市',
  'en': 'Wuwei'
},
{
  'zh': '无锡市',
  'en': 'Wuxi'
},
{
  'zh': '吴忠市',
  'en': 'Wuzhong'
},
{
  'zh': '梧州市',
  'en': 'Wuzhou'
},
{
  'zh': '西安市',
  'en': "Xi'an"
},
{
  'zh': '厦门市',
  'en': 'Xiamen'
},
{
  'zh': '襄樊市',
  'en': 'Xiangfan'
},
{
  'zh': '湘潭市',
  'en': 'Xiangtan'
},
{
  'zh': '湘西土家族苗族自治州',
  'en': 'Xiangxi'
},
{
  'zh': '咸宁市',
  'en': 'Xianning'
},
{
  'zh': '咸阳市',
  'en': 'Xianyang'
},
{
  'zh': '孝感市',
  'en': 'Xiaogan'
},
{
  'zh': '新北市',
  'en': 'Xinbei'
},
{
  'zh': '兴安盟',
  'en': 'Xinganmeng'
},
{
  'zh': '邢台市',
  'en': 'Xingtai'
},
{
  'zh': '西宁市',
  'en': 'Xining'
},
{
  'zh': '新乡市',
  'en': 'Xinxiang'
},
{
  'zh': '信阳市',
  'en': 'Xinyang'
},
{
  'zh': '新余市',
  'en': 'Xinyu'
},
{
  'zh': '忻州市',
  'en': 'Xinzhou'
},
{
  'zh': '西双版纳傣族自治州',
  'en': 'Xishuangbanna'
},
{
  'zh': '宣城市',
  'en': 'Xuancheng'
},
{
  'zh': '许昌市',
  'en': 'Xuchang'
},
{
  'zh': '徐州市',
  'en': 'Xuzhou'
},
{
  'zh': '雅安市',
  'en': "Ya'an"
},
{
  'zh': '延安市',
  'en': "Yan'an"
},
{
  'zh': '延边朝鲜族自治州',
  'en': 'Yanbian'
},
{
  'zh': '盐城市',
  'en': 'Yancheng'
},
{
  'zh': '阳江市',
  'en': 'Yangjiang'
},
{
  'zh': '阳泉市',
  'en': 'Yangquan'
},
{
  'zh': '扬州市',
  'en': 'Yangzhou'
},
{
  'zh': '烟台市',
  'en': 'Yantai'
},
{
  'zh': '宜宾市',
  'en': 'Yibin'
},
{
  'zh': '宜昌市',
  'en': 'Yichang'
},
{
  'zh': '宜春市',
  'en': 'Yichun'
},
{
  'zh': '伊犁哈萨克自治州',
  'en': 'Yili'
},
{
  'zh': '银川市',
  'en': 'Yinchuan'
},
{
  'zh': '营口市',
  'en': 'Yingkou'
},
{
  'zh': '鹰潭市',
  'en': 'Yingtan'
},
{
  'zh': '益阳市',
  'en': 'Yiyang'
},
{
  'zh': '永州市',
  'en': 'Yongzhou'
},
{
  'zh': '岳阳市',
  'en': 'Yueyang'
},
{
  'zh': '玉林市',
  'en': 'Yulin'
},
{
  'zh': '运城市',
  'en': 'Yuncheng'
},
{
  'zh': '云浮市',
  'en': 'Yunfu'
},
{
  'zh': '玉树藏族自治州',
  'en': 'Yushu'
},
{
  'zh': '玉溪市',
  'en': 'Yuxi'
},
{
  'zh': '枣庄市',
  'en': 'Zaozhuang'
},
{
  'zh': '张家界市',
  'en': 'Zhangjiajie'
},
{
  'zh': '张家口市',
  'en': 'Zhangjiakou'
},
{
  'zh': '张掖市',
  'en': 'Zhangye'
},
{
  'zh': '漳州市',
  'en': 'Zhangzhou'
},
{
  'zh': '湛江市',
  'en': 'Zhanjiang'
},
{
  'zh': '肇庆市',
  'en': 'Zhaoqing'
},
{
  'zh': '昭通市',
  'en': 'Zhaotong'
},
{
  'zh': '郑州市',
  'en': 'Zhengzhou'
},
{
  'zh': '镇江市',
  'en': 'Zhenjiang'
},
{
  'zh': '中山市',
  'en': 'Zhongshan'
},
{
  'zh': '中卫市',
  'en': 'Zhongwei'
},
{
  'zh': '周口市',
  'en': 'Zhoukou'
},
{
  'zh': '舟山市',
  'en': 'Zhoushan'
},
{
  'zh': '珠海市',
  'en': 'Zhuhai'
},
{
  'zh': '驻马店市',
  'en': 'Zhumadian'
},
{
  'zh': '株洲市',
  'en': 'Zhuzhou'
},
{
  'zh': '淄博市',
  'en': 'Zibo'
},
{
  'zh': '自贡市',
  'en': 'Zigong'
},
{
  'zh': '资阳市',
  'en': 'Ziyang'
},
{
  'zh': '遵义市',
  'en': 'Zunyi'
}]

const cityFormat = (() => {
  const obj = {
    zh: [],
    en: []
  }
  for (const i in city) {
    obj.zh.push(city[i]['zh'])
    obj.en.push(city[i]['en'])
  }
  return obj
})()

export default cityFormat
